import { createSlice } from "@reduxjs/toolkit";

const initialState: boolean = true;

const dummyAccountSettingSlice = createSlice({
  name: "settings/excludeDummyAccount",
  initialState: initialState,
  reducers: {
    setDummyAccountSetting: (state, { payload }) => {
      return payload;
    },
  },
});

export const { setDummyAccountSetting } = dummyAccountSettingSlice.actions;

export default dummyAccountSettingSlice.reducer;
